import { mgPrisConfig } from '@retail/mgpris/config';

export const isRunnningLocally = mgPrisConfig.version === 'local';
